import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stateType } from './types';

const initialState: stateType = {
  leg: false,
  leg_count: 1,
  anchor: false,
  anchor_count: 1,
  anchorPosition: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  lastClickTime: Date.now(),
  canDoubleHooks: false,
  randomSpeach: 0,
};

export const hooks = createSlice({
  name: 'hooks',
  initialState,
  reducers: {
    againHooks(state) {
      state.leg_count = 1;
      state.anchor_count = 1;
    },
    doubleHooks(state) {
      if (state.leg_count + 2 < 3) {
        state.leg_count = state.leg_count + 2;
      } else {
        state.leg_count = 2;
      }

      if (state.anchor_count + 2 < 3) {
        state.anchor_count = state.anchor_count + 2;
      } else {
        state.anchor_count = 2;
      }
    },
    setCanDoubleHooks(state, action: PayloadAction<boolean>) {
      state.canDoubleHooks = action.payload;
    },
    setRandomSpeach(state, action: PayloadAction<number>) {
      state.randomSpeach = action.payload;
    },
    setIsLegTrue(state) {
      if (state.leg_count > 0) {
        state.leg = true;
        state.leg_count = state.leg_count - 1;
      }
    },
    setIsLegFalse(state) {
      state.leg = false;
    },
    setIsAnchorTrue(state) {
      if (state.anchor_count > 0) {
        state.anchor = true;
        state.anchor_count = state.anchor_count - 1;
      }
    },
    setHooks(state, action: PayloadAction<number>) {
      state.anchor_count = action.payload;
      state.leg_count = action.payload;
    },
    setIsAnchorFalse(state) {
      state.anchor = false;
    },

    setAnchorPosition(
      state,
      action: PayloadAction<{ top: number; right: number; bottom: number; left: number }>,
    ) {
      state.anchorPosition = action.payload;
    },
    updateLastClickTime(state) {
      state.lastClickTime = Date.now();
    },
  },
});

export const {
  againHooks,
  doubleHooks,
  setRandomSpeach,
  setHooks,
  setIsLegTrue,
  setIsLegFalse,
  setIsAnchorTrue,
  setIsAnchorFalse,
  updateLastClickTime,
  setAnchorPosition,
  setCanDoubleHooks,
} = hooks.actions;

export default hooks.reducer;
